import { Stack } from '@mui/material';
import { useFormContext, useFormState, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { Button } from '@/shared/components/ui/button/button';
import { TextButton } from '@/shared/components/ui/button/text-button/text-button';
import { FormInput } from '@/shared/components/ui/form/components/form-input/form-input';
import { FormContent } from '@/shared/components/ui/form/form-content';
import { FormContainer } from '@/shared/components/ui/form/form.styled';
import { TLoginInputSchema } from '@/shared/features/auth/components/login/login.types';

export const LoginWithCredentialsForm = () => {
  const { t } = useTranslation();
  const { control } = useFormContext<TLoginInputSchema>();
  const { isSubmitting } = useFormState<TLoginInputSchema>();
  const password = useWatch({
    control,
    name: 'password',
  });
  const isValidPassword = password && password.length >= 8;
  const navigate = useNavigate();

  return (
    <FormContainer gap="2rem">
      <FormContent>
        <FormInput<TLoginInputSchema>
          name="username"
          label={t('auth:email')}
          placeholder={t('auth:enter_email')}
          type="email"
          required
        />
        <Stack gap="0.5rem" alignItems="flex-end">
          <FormInput<TLoginInputSchema>
            name="password"
            label={t('auth:password')}
            placeholder={t('auth:enter_password')}
            type="password"
            required
          />
          <TextButton
            variant="primaryLighter"
            onClick={() => navigate('/auth/reset-password')}
          >
            {t('auth:forgot_your_password')}
          </TextButton>
        </Stack>
      </FormContent>
      <Button
        type="submit"
        variant="primary"
        fullWidth={true}
        size="large"
        disabled={isSubmitting || !isValidPassword}
      >
        {t('auth:submit')}
      </Button>
    </FormContainer>
  );
};
